export enum ReceiveOrderStatus {
    Order = 1,
    Received = 2,
    Completed = 3,
}
